import React from 'react'
import { useTranslation } from 'react-i18next'
import { IComment, ILessonExtended, PayloadComment } from 'src/service/api/api.types'
import { useDispatch, useSelector } from 'react-redux'
import { State } from 'src/store/rootReducers'
import { Button } from 'src/components/Common/Button'
import { useFormik } from 'formik'
import * as Yup from 'yup'
import { FormProvider } from 'src/components/Common/Form'
import InputContainer from 'src/components/Common/InputContainer'
import { apiPrivate } from 'src/service/api/api.private'
import { updateComments } from 'src/store/lessons'
import { IoIosCloseCircle } from 'react-icons/io'
import {BoxForm} from "src/components/Curso/Classroom/Comments/styles";
import {toast} from "react-toastify";

interface Props {
  idParent?: string
  hasCardComment: boolean
  setIsResponse?: React.Dispatch<React.SetStateAction<boolean>>
}

const Form: React.FC<Props> = props => {
  const { t } = useTranslation()
  const module = useSelector((state: State) => state.course.module)
  const [isLoading, setIsLoading] = React.useState(false)
  const dispatch = useDispatch()

  const formik = useFormik({
    initialValues: {
      comment: '',
    },
    onSubmit: async values => {
      setIsLoading(true)
      if (module) {
        let payload: PayloadComment = {
          comment: values.comment,
        }

        if (props.idParent) {
          payload = { ...payload, parentCommentId: props.idParent }
        }

        const res = await apiPrivate.sendComment(module.id, payload)

        if (res.kind === 'ok') {
          dispatch(updateComments(res.data))
          if(!props.idParent) {
            toast(t('toast.commentSuccess'), { type: 'success' })
          }
        }

        formik.resetForm()
        setIsLoading(false)
        if (props.setIsResponse) {
          props.setIsResponse(false)
        }
      }
    },
    validationSchema: Yup.object({
      comment: Yup.string().required(t('validation.required')),
    }),
  })

  return (
    <>
      <BoxForm hasResponse={props.hasCardComment ?? false}>
        <FormProvider provider={formik} className="form-comment">
          {props.hasCardComment ? (
            <div className="closed">
              <span onClick={() => props.setIsResponse && props.setIsResponse(false)}>
                <IoIosCloseCircle className="icon" />
                {t('classroom.comment.closed')}
              </span>
            </div>
          ) : null}
          <InputContainer
            name="comment"
            component="textarea"
            placeholder={t('classroom.comment.placeholder')}
            preset={props.hasCardComment ? 'commentChildren' : 'comment'}
            cols="40"
            rows="5"
          />
          <Button
            preset="primary"
            type="submit"
            isLoading={isLoading}
            labelTx="classroom.comment.btn"
          />
        </FormProvider>
      </BoxForm>
    </>
  )
}

export default React.memo(Form)
